import React from 'react'

export default class IconCopyClipboardOutline extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'

        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='20'
                viewBox='0 0 20 20'
                fill='none'
            >
                <path
                    d='M8.33333 7.5H15C15.9205 7.5 16.6667 8.24619 16.6667 9.16667V15.8333C16.6667 16.7538 15.9205 17.5 15 17.5H8.33333C7.41286 17.5 6.66667 16.7538 6.66667 15.8333V9.16667C6.66667 8.24619 7.41286 7.5 8.33333 7.5Z'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M3.33333 12.5C2.41286 12.5 1.66667 11.7538 1.66667 10.8333V4.16667C1.66667 3.24619 2.41286 2.5 3.33333 2.5H10C10.9205 2.5 11.6667 3.24619 11.6667 4.16667V4.99999'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
